import { Helmet } from "react-helmet-async";

const SITE = "https://gravitastechnologysol.com";
const DEFAULT_OG =
  "https://images.pexels.com/photos/586056/pexels-photo-586056.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=630&w=1200";

const SEO = ({ title, description, path = "/", image = DEFAULT_OG }) => {
  const fullTitle = title
    ? `${title} | Gravitas Technology Solutions`
    : "Gravitas Technology Solutions | Federal & Enterprise IT Consulting — Washington DC";
  const url = `${SITE}${path}`;
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content={image} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
};

export default SEO;
